import Cookies from 'js-cookie'
import { COOKIE_DOMAIN, QUERY_UTM_COOKIE, QUERY_UTM_COOKIE_DAYS, collectTouch } from './attribution-utils'

const writeQueryUtmCookie = (value) => {
  const expires = new Date(Date.now() + QUERY_UTM_COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString()
  // eslint-disable-next-line max-len
  document.cookie = `${QUERY_UTM_COOKIE}=${encodeURIComponent(value)}; domain=${COOKIE_DOMAIN}; Secure; SameSite=None; path=/; expires=${expires}`
};

(function saveLastTouch() {
  const { search } = window.location
  const touch = collectTouch({
    search,
    referrer: document.referrer,
    pathname: window.location.pathname,
  })

  if (Object.keys(touch).length > 0) {
    writeQueryUtmCookie(JSON.stringify(touch))

    if (!search.includes('utm')) {
      const url = new URL(window.location.href)
      Object.entries(touch).forEach(([key, value]) => url.searchParams.set(key, value))
      window.history.replaceState(window.history.state, '', url.toString())
    }

    return
  }

  const params = new URLSearchParams(search)
  const lp = params.get('lp')
  if (!lp) return

  const previous = JSON.parse(Cookies.get(QUERY_UTM_COOKIE) || '{}')
  const next = { ...previous, lp, lp_path: params.get('lp_path') || '' }
  writeQueryUtmCookie(JSON.stringify(next))
}())
